// extracted by mini-css-extract-plugin
export var root = "L_wq";
export var wrapper = "L_qh";
export var image = "L_wr d_w d_y d_W";
export var imageWithHeight = "L_ws";
export var crop = "L_wt";
export var round = "L_wv";
export var fixedHeight = "L_ww";